module.exports = __webpack_public_path__ + "img/qa-top.07f3ee6a.png";